import { iconChevronSmall, iconChevronSmall180 } from '@tesla/design-system-icons';
import React, { useRef } from 'react';
import { Icon, IconButton, ListBox, Tooltip, TooltipWrapper, useListBoxState, useTooltipState, } from '../index.js';
import { toLabel } from '../listbox/index.js';
/**
 * TODO:s
 * - manage state internally if none is provided?
 */
export const InlineDropdown = ({ align = 'start', autoCloseOnOptionSelect = true, icon, id, listBoxProps, listBoxState: externalListBoxState, onOptionSelect, open, options, selected, tooltipProps, trigger, triggerRef, visuallySelected, ...rest }) => {
    const { expanded, handlers, setExpanded, toggleExpanded, wrapperRef } = useTooltipState();
    const fallbackListBoxState = useListBoxState();
    const listBoxState = externalListBoxState !== null && externalListBoxState !== void 0 ? externalListBoxState : fallbackListBoxState;
    const listboxRef = useRef(null);
    const fallbackRef = useRef(null);
    const ref = triggerRef || fallbackRef;
    // Replicate the keyboard triggers of a native select
    const handleKeyDown = (e) => {
        var _a;
        switch (e.key) {
            case ' ':
            case 'ArrowDown':
            case 'ArrowUp':
            case 'Enter':
            case 'Return':
                e.preventDefault();
                setExpanded(true);
                (_a = listboxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                break;
        }
        // @ts-expect-error - React's event types are not self-compatible in this case
        handlers.onKeyDown(e);
    };
    const handleOptionSelect = (option) => {
        var _a;
        onOptionSelect(option);
        // Allow users to opt-out of the default onSelect behavior
        if (autoCloseOnOptionSelect) {
            setExpanded(false);
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    return (React.createElement(TooltipWrapper, { id: id, inline: true, wrapperRef: wrapperRef, ...rest },
        !icon ? (React.createElement("button", { "aria-haspopup": "listbox", className: "tds-dropdown-trigger", onClick: toggleExpanded, onKeyDown: handleKeyDown, ref: ref, type: "button" }, trigger ? (trigger) : (React.createElement(React.Fragment, null,
            React.createElement("span", null, visuallySelected !== null && visuallySelected !== void 0 ? visuallySelected : toLabel(selected)),
            React.createElement(Icon, { data: (open !== null && open !== void 0 ? open : expanded) ? iconChevronSmall : iconChevronSmall180, inline: true }))))) : (React.createElement(IconButton, { onClick: toggleExpanded, onKeyDown: handleKeyDown }, icon)),
        React.createElement(Tooltip, { align: align, className: "tds-dropdown", open: open !== null && open !== void 0 ? open : expanded, orientation: "down", ...tooltipProps },
            React.createElement(ListBox, { ...listBoxState, id: id ? `${id}-listbox` : undefined, listboxRef: listboxRef, onOptionSelect: handleOptionSelect, options: options, selected: selected, ...listBoxProps }))));
};
